import styled from 'styled-components'
import { Hr } from 'ui/components'

const HrWithBottomMargin = styled(Hr)`
  margin-bottom: 21px;
`

export const s = { HrWithBottomMargin }
